(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
      
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Gestion du sélecteur de langue - LOGIQUE ORIGINALE AMÉLIORÉE
  document.addEventListener('DOMContentLoaded', function() {
    console.log('🌐 Initialisation du sélecteur de langue');

    // Gérer les boutons de langue avec la logique originale
    const languageButtons = document.querySelectorAll('.header__language-link');
    console.log('🔍 Debug - Boutons langue trouvés:', languageButtons.length);
    
    if (languageButtons.length === 0) {
      console.warn('⚠️ Aucun bouton de langue trouvé');
      return;
    }

    languageButtons.forEach((button, index) => {
      console.log(`📋 Bouton ${index + 1}:`, button.dataset.locale, button.textContent);
      
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const newLocale = this.dataset.locale;
        const form = this.closest('form');
        const localeInput = form ? form.querySelector('#current-locale') : null;
        
        console.log('🌐 Changement de langue vers :', newLocale);
        console.log('📋 Formulaire trouvé:', !!form);
        console.log('📋 Input trouvé:', !!localeInput);
        
        if (localeInput && form) {
          console.log('✅ Ancienne valeur:', localeInput.value);
          localeInput.value = newLocale;
          console.log('✅ Nouvelle valeur:', localeInput.value);
          
          // Afficher un indicateur de chargement
          const originalText = this.textContent;
          this.style.opacity = '0.5';
          this.textContent = '...';
          
          // Soumettre le formulaire
          console.log('📤 Soumission du formulaire...');
          form.submit();
        } else {
          console.error('❌ Erreur - Input locale ou formulaire non trouvé');
          console.error('  - Formulaire:', form);
          console.error('  - Input:', localeInput);
          
          // Fallback: essayer de soumettre directement
          if (form) {
            console.log('🔄 Tentative fallback...');
            const fallbackInput = document.createElement('input');
            fallbackInput.type = 'hidden';
            fallbackInput.name = 'locale_code';
            fallbackInput.value = newLocale;
            form.appendChild(fallbackInput);
            form.submit();
          }
        }
      });
    });

    // Vérifier la structure du DOM
    const form = document.querySelector('#HeaderLanguageForm');
    const localeInput = document.querySelector('#current-locale');
    const allInputs = document.querySelectorAll('input[name="locale_code"]');
    
    console.log('📊 État du DOM:');
    console.log('  - Formulaire #HeaderLanguageForm:', !!form);
    console.log('  - Input #current-locale:', !!localeInput);
    console.log('  - Inputs locale_code trouvés:', allInputs.length);
    
    if (form) {
      console.log('  - Action du formulaire:', form.action);
      console.log('  - Méthode du formulaire:', form.method);
    }
  });

  // Classe LocalizationForm pour compatibilité avec le thème
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
    }

    connectedCallback() {
      console.log('🔗 LocalizationForm connecté:', this.id || 'sans ID');
      
      // Vérifier si les éléments sont présents
      if (this.elements.input) {
        console.log('  ✅ Input trouvé:', this.elements.input.name);
      }
      if (this.elements.button) {
        console.log('  ✅ Button trouvé');
      }
    }

    hidePanel() {
      if (this.elements.button && this.elements.panel) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      if (this.elements.button) this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      if (this.elements.input && form) {
        this.elements.input.value = event.currentTarget.dataset.value;
        
        // Ajouter un indicateur de chargement
        const button = event.currentTarget;
        const originalText = button.textContent;
        button.style.opacity = '0.6';
        button.textContent = '...';
        
        form.submit();
      }
    }

    openSelector() {
      if (this.elements.button && this.elements.panel) {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              $('.loading-image').removeClass('loading-image').addClass('loaded-image');
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
